import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/modal_EnforceStorageLimitQuery$parameters';

type EntryPointParams = {
	cloudId: string;
	productKey: string;
};

export const enforceStorageLimitsModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-enforce-storage-limits-modal-entrypoint" */ './index'),
	),
	getPreloadProps: ({ cloudId, productKey }: EntryPointParams) => ({
		queries: {
			changeOffering: {
				parameters,
				variables: {
					cloudId,
					productKey,
					offeringName: 'standard',
				},
			},
		},
	}),
});
